module.exports = __webpack_public_path__ + "static/media/fail.11d5a413.m4a";